// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".token-title[data-v-6d0e3a51]{display:block;text-decoration:underline}.my-search-token-v2[data-v-6d0e3a51]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
